<template>
  <div>
    <div v-if="isMobile">
      <v-expand-x-transition>
        <v-text-field
          v-show="showSearchBar"
          placeholder="Rechercher"
          prepend-inner-icon="mdi-magnify"
          hide-details
          dense
          filled
          single-line
          :autofocus="focusSearchBar"
          @blur="showSearchbarAndFocus(false)"
          v-model="search"
          :loading="loading"
          @keydown="() => clearTypingTimer(typingTimerIdSearchTerm)"
          @keyup="triggerTypingTimerSearchTerm"
        >
        </v-text-field>
      </v-expand-x-transition>
      <v-btn
        v-show="!showSearchBar"
        text
        dark
        icon
        @click="showSearchbarAndFocus(true)"
      >
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </div>
    <div style="min-width: 500px" v-else>
      <v-text-field
        v-model="search"
        placeholder="Recherche..."
        hide-details
        filled
        prepend-inner-icon="mdi-magnify"
        dense
        single-line
        :loading="loading"
        @keydown="() => clearTypingTimer(typingTimerIdSearchTerm)"
        @keyup="triggerTypingTimerSearchTerm"
      ></v-text-field>
    </div>
  </div>
</template>
<script>
import { defineComponent, computed, ref, toRefs } from "@vue/composition-api";
import { useGlobalSearch } from "@/composables/global-search";

export default defineComponent({
  setup(props, { root }) {
    /* Import des API */
    const { globalSearchData, globalSearch } = useGlobalSearch();

    /* Variables */
    const showSearchBar = ref(false);
    const focusSearchBar = ref(false);
    let typingTimerIdSearchTerm = 0;
    const debounceInterval = 500;

    /* Computed */
    const isMobile = computed(function () {
      return root.$vuetify.breakpoint.mobile;
    });

    /* Méthodes */
    const showSearchbarAndFocus = function (show) {
      showSearchBar.value = show;
      focusSearchBar.value = show;
    };
    const clearTypingTimer = function (timerId) {
      clearTimeout(timerId);
    };
    const triggerTypingTimerSearchTerm = function () {
      clearTimeout(typingTimerIdSearchTerm);
      typingTimerIdSearchTerm = setTimeout(function () {
        globalSearch();
      }, debounceInterval);
    };

    return {
      isMobile,
      showSearchBar,
      focusSearchBar,
      showSearchbarAndFocus,
      ...toRefs(globalSearchData),
      globalSearch,
      clearTypingTimer,
      typingTimerIdSearchTerm,
      triggerTypingTimerSearchTerm,
    };
  },
});
</script>
